import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';

const Container = styled.div`
  color: #3d3d3d;
  font-family: 'Pluto Sans SemiBold', sans-serif;
  line-height: 1.3;
  margin: 1.5em 1em;
  width: 268px;
`;

const Title = styled.div`
  color: #000000;
  font-family: 'Pluto Sans Bold', sans-serif;
  font-size: 2em;
  font-weight: bold;
  text-align: center;
`;

const Centered = styled.div`
  font-size: 1.1em;
  line-height: 26px;
  margin: 0.8em 0 1.5em;
  text-align: center;
`;

const Link = styled.a`
  color: #5e00ff;
  cursor: pointer;
`;

const BottomLinks = styled.div`
  font-size: 1em;
  white-space: nowrap;
  text-align: center;
  ${Link} + ${Link}:before {
    color: #979797;
    content: '|';
    margin: 0 1em;
  }
`;

const styles = {
  button: {
    background: '#ffde2b',
    borderRadius: '18px',
    boxShadow: 'none',
    fontSize: '16px',
    marginTop: '6px',
    padding: '0.2em 1.2em',
    textAlign: 'center',
  },
};

export const SignUpPromoComponent = ({ classes, openDialog, t }) => (
  <Container className="signup-promo-container">
    <Title>{t('sign_up_its_free', 'Sign up. It’s free.')}</Title>
    <Centered>
      {t('stay_up_to_date', 'Stay up to date on all our new channels, movies, & lineups')}!
    </Centered>
    <Centered>
      <Button
        className={classes.button}
        color="primary"
        onClick={(e) => openDialog(e, 'signUp')}
        variant="contained"
      >
        {t('sign_up_for_free', 'Sign up for Free')}
      </Button>
    </Centered>
    <BottomLinks>
      {t('already_have_account', 'Already have an account')}{' '}
      <Link onClick={(e) => openDialog(e, 'signIn')}>{t('sign_in')}</Link>
    </BottomLinks>
  </Container>
);
SignUpPromoComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  openDialog: PropTypes.func.isRequired,
};

export const SignUpPromo = withStyles(styles)(withNamespaces()(SignUpPromoComponent));
